import { observable } from 'mobx';
import {ArtistSchema, TrackSchema} from '../../types/schema';

export class CacheModel {
  @observable
  track: {[identity: string]: TrackSchema} = {};

  @observable
  artist: {[identity: string]: ArtistSchema} = {};
}